import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    CardBody,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../helpers/Utils';
import {
    putAPI_Update_Ingetration,
    gAPI_Ingetration,
    gAPI_Property_List_By_Group,
    dAPI_Delete_Ingetration,
} from '../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import { faHandSpock } from '@fortawesome/free-regular-svg-icons';
import {
    faPalette,
    faLanguage,
    faComment,
    faLocationArrow,
} from '@fortawesome/free-solid-svg-icons';
import { faWpforms } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import BookingEngineUrlIntegration from './BookingEngineUrlIntegration';

function BookingEngineUrlIntegrationList({ match, history, propertyId }) {
    const [integrationId, setIntegrationId] = useState(undefined);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [propertyData, setPropertyData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState([]);
    const [integrationData, setIntegrationData] = useState({
        groupId: getGroupID(),
        name: '',
        properties: [],
        sessionTimeoutInSeconds: 600,
        defaultLanguage: 'en-US',
        disabled: false,
        bookingEngineUrls: []
    });
    useEffect(() => {
        const urll = window.location.pathname;
        const id = urll.substring(urll.lastIndexOf('/') + 1);
        if (id !== "booking-engine-url") {
            setIntegrationId(id);
            console.log(id);
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Ingetration}/${id}?group_id=${getGroupID()}`,
            }).then((res) => {
                let channelDetails = res.data.channelDetails;
                setIntegrationData({
                    ...integrationData,
                    name: res.data.name,
                    properties: [],
                    disabled: res.data.disabled,
                    bookingEngineUrls: [...res.data.channelDetails]
                });
                AxiosAPI({
                    method: 'get',
                    url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
                })
                    .then(resprop => {
                        resprop.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
                        if (channelDetails !== null && channelDetails.length > 0) {
                            let firstProperty = channelDetails[0].propertyId;
                            const result = resprop.data.find(elem => elem.id === firstProperty);
                            setSelectedProperty([result]);
                        }
                        else {
                            if (selectedProperty.length === 0) {
                                setSelectedProperty([resprop.data[0]]);
                            }
                        }
                        setPropertyData([...resprop.data]);

                    })
                    .catch(err => console.error(err));
            })
                .catch((err) => console.log('err', err));

        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    //console.log(res.data);
                    res.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
                    if (selectedProperty.length === 0) {
                        setSelectedProperty([res.data[0]]);
                    }
                    setPropertyData([...res.data]);

                })
                .catch(err => console.error(err));
        }
    }, []);

    const handleClickProperty = (id) => {
        let property = propertyData.filter((item) => item.id === id);
        setSelectedProperty(property);
    }
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const handleDelete = () => {
        AxiosAPI({
            method: 'delete',
            url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
        }).then(res => {
            setTimeout(() => {
                history.push('/app/pages/integration/applications');
            }, 300)
        });
    };
    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This integration will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            {propertyData && (
                <Fragment>
                    <Row>
                        <Colxx md="12" sm="12" lg="12" xxs="12">
                            <NavLink to={{ pathname: '/app/pages/integration/applications' }}>
                                <h1 className="iconsminds-back" />
                            </NavLink>
                        </Colxx>
                    </Row>
                    <Row>
                        <Colxx xxs="12" md="6" className="mb-4">
                            <Card>
                                <CardBody>
                                    {propertyData && propertyData.map((item, index) => (
                                        <div key={index} className={`mb-3 integration ${selectedProperty.length > 0 && selectedProperty[0].id === item.id ? 'integration--active' : ''}`}>
                                            <div className="glyph">
                                                <div className={`glyph-icon iconsminds-hotel`} />
                                            </div>
                                            <NavLink
                                                to="#"
                                                className="w-40 w-sm-100"
                                                onClick={(e) => handleClickProperty(item.id)}
                                            >
                                                <Row>
                                                    <Colxx xxs="12" md="10">
                                                        <p className="list-item-heading mb-1 color-theme-1">
                                                            {item.name}
                                                        </p>
                                                        <p className="mb-4 text-small">

                                                        </p>
                                                    </Colxx>
                                                    <Colxx xxs="12" md="2">
                                                        <div className="glyph">
                                                            <div
                                                                className={`glyph-icon-min iconsminds-arrow-forward-2`}
                                                            />
                                                        </div>
                                                    </Colxx>
                                                </Row>
                                            </NavLink>
                                            <Separator />
                                        </div>
                                    ))}
                                    <div>
                                        <Button
                                            color="dark"
                                            outline
                                            style={{
                                                width: '100%',
                                                borderRadius: '6px',
                                            }}
                                            className="mb-4"
                                            onClick={toggle}
                                        >
                                            Archive
                                        </Button>

                                        <Separator />
                                    </div>
                                </CardBody>
                            </Card>
                        </Colxx>
                        <Colxx xxs="12" md="6" className="mb-4">
                            <Card className="mb-4">
                                {selectedProperty.length > 0 && (
                                    <BookingEngineUrlIntegration
                                        selectedProperty={selectedProperty}
                                        integrationId={integrationId}
                                        integrationData={integrationData}
                                    ></BookingEngineUrlIntegration>
                                )}

                            </Card>
                        </Colxx>
                    </Row>
                </Fragment>
            )}
            {generateDeleteButton()}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId
    };
};

export default injectIntl(connect(mapStateToProps, {})(BookingEngineUrlIntegrationList));